import {Button, Group, Modal} from '@mantine/core';
import React, {useState} from 'react';

import {AntibodyFormat} from 'antibodies/AntibodyTypedefs';
import ProteinCreationComponentSelectionPane from 'antibodies/nested-data-creation/full-screen/ProteinCreationComponentSelectionPane';
import {NdcSpreadsheetComponentFormatType} from 'antibodies/nested-data-creation/spreadsheet-import/constants/AntibodyNestedDataCreationSpreadsheetImportConstants';
import ModalFooter from 'ui-library/modals/ModalFooter';

export const ADD_FROM_SEARCH_TITLE = 'Add from search';

interface ProteinCreationSearchModalProps {
  format: AntibodyFormat;
  startingType: NdcSpreadsheetComponentFormatType;
  onClose: () => void;
}

/**
 * Adds sequences to a component column of the protein creation table, starting with picking the column.
 */
export default function ProteinCreationSearchModal({
  format,
  startingType,
  onClose,
}: ProteinCreationSearchModalProps): JSX.Element {
  const [selectedLabel, setSelectedLabel] = useState<string | null>(null);

  return (
    <Modal
      title={ADD_FROM_SEARCH_TITLE}
      opened={true}
      onClose={onClose}
      size="xl"
      closeButtonProps={{'aria-label': 'Close'}}
      lockScroll={false}
    >
      <ProteinCreationComponentSelectionPane
        format={format}
        startingType={startingType}
        selectedLabel={selectedLabel}
        onSelectLabel={setSelectedLabel}
      />
      <ModalFooter>
        <Group position="apart">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button disabled={true}>Next</Button>
        </Group>
      </ModalFooter>
    </Modal>
  );
}
